import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/** Keyboard key hint, for example <Kbd>⌘K</Kbd>. */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-line-strong bg-surface-2 px-1 font-mono text-[0.6875rem] leading-none font-medium text-ink-2',
        className,
      )}
    >
      {children}
    </kbd>
  )
}
